import React, { useEffect, useState } from "react";
import { useAuth } from "component/UseAuth";
import { showConfirm, showSuccess, showError } from "component/utils/SweetAlert";
import axios from "axios";

import Sidebar from "component/Sidebar";
import Navbar from "component/Navbar";
import Datatables from "component/hrd/employee/Datatables";
import FormEmployee from "component/hrd/employee/FormEmployee";

function Employee() {
  const { user } = useAuth();
  const [mode, setMode] = useState(null);
  const [activeContent, setActiveContent] = useState("data");
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [employee, setEmployee] = useState([]);

  const fetchEmployee = async (status = "All") => {
    const token = localStorage.getItem("token");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API}/show-employee?status=${status}`,
        {
          method: "GET",
          headers: {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      if (!response.ok) throw new Error("Gagal mengambil data employee");

      const data = await response.json();
      setEmployee(data.data);
    } catch (error) {
      console.error("Error fetching employee:", error);
    }
  };

  useEffect(() => {
      document.title = "Green Hill Kemuning | Employee";
      window.scrollTo(0, 0);
  }, []);


  const handleAddEmployee = () => {
    setMode("add");
    setSelectedEmployee(null);
    setActiveContent("form");
  }

  const handleEditEmployee = (employee) => {
    setMode("edit");
    setSelectedEmployee(employee);
    setActiveContent("form");
  }

  const handleDeleteEmployee = async (employee) => {
    try {
      const confirmed = await showConfirm({
        title: 'Hapus Karyawan',
        text: `Apakah Anda yakin ingin menghapus Karyawan ${employee.NAMA_LENGKAP}?`,
        confirmButtonText: 'Hapus'
      });
      if (!confirmed) return;
  
      if (!employee?.KARYAWAN_ID) {
        alert("Employee ID tidak ditemukan");
        return;
      }

      const response = await axios.delete(
        `${process.env.REACT_APP_API}/employee/${employee.KARYAWAN_ID}`
      );

  
      if (response.status === 200 || response.status === 201) {
        showSuccess(response.data.message || "Employee berhasil dihapus");
        fetchEmployee();
      } else {
        showError(response.data.message || "Gagal menghapus Employee");
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      showError(error.response?.data?.message || "Terjadi kesalahan saat menghapus Employee");
    }
  }; 

  const handleBack = () => {
    fetchEmployee();
    setActiveContent("data");
  };
      
  return (
    <div class="layout-wrapper layout-content-navbar">
      <div class="layout-container">
        <Sidebar />

        <div class="layout-page" style={{ backgroundColor: "#f8f9fa" }}>
            <Navbar />
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                  <div class="row px-4">
                      <div class="card shadow p-3">
                        <div class="card-body">

                          {activeContent === "data" && (
                          <div class="row">
                            <div className="d-flex justify-content-between align-items-center">
                              <h5 className="card-title m-0">Employee Management</h5>
                              <i className="bx bxs-plus-square" 
                                style={{ color: "blue", fontSize: 50, cursor: "pointer" }} 
                                onClick={handleAddEmployee}>
                              </i>
                            </div>
                            <Datatables 
                              data={employee} 
                              onEditEmployee={handleEditEmployee} 
                              onDeleteEmployee={handleDeleteEmployee}
                              onFetchEmployee={fetchEmployee}
                            />
                          </div>
                          )}

                          {activeContent === "form" && (
                          <div class="row">
                            <div className="d-flex justify-content-between align-items-center">
                              <h5 className="card-title m-0">Form Input Employee</h5>
                            </div>
                            <FormEmployee
                              user={user}
                              mode={mode}
                              employeeData={selectedEmployee}
                              onBack={handleBack}
                              onSuccess={fetchEmployee}
                            />
                          </div>
                          )}

                        </div>  
                      </div>
                  </div>
                </div>
            </div>
        </div>
      </div>
      <div class="layout-overlay layout-menu-toggle"></div>

    </div>
  );
}

export default Employee;
